// Trix customizations - imported from application.js to share the same Trix instance
import Trix from "trix"

// Text attribute for button (inline span wrapper)
Trix.config.textAttributes.button = {
  tagName: "span",
  inheritable: true,
  parser(element) {
    return element.tagName.toLowerCase() === "span"
  }
}

// Block attributes for headings and structural elements
Trix.config.blockAttributes.headingTwo = {
  tagName: "h2",
  terminal: true,
  breakOnReturn: true,
  group: false
}

Trix.config.blockAttributes.headingThree = {
  tagName: "h3",
  terminal: true,
  breakOnReturn: true,
  group: false
}

Trix.config.blockAttributes.headingFour = {
  tagName: "h4",
  terminal: true,
  breakOnReturn: true,
  group: false
}

Trix.config.blockAttributes.paragraph = {
  tagName: "p",
  terminal: true,
  breakOnReturn: true,
  group: false
}

Trix.config.blockAttributes.center = {
  tagName: "section",
  terminal: true,
  breakOnReturn: true,
  group: false
}

/* insert the button visual in the default toolbar */
addEventListener("trix-initialize", function(event) {
  var buttonHTML = '<button class="trix-button" type="button" data-trix-attribute="button">Button</button>'
  buttonHTML += '<button class="trix-button" type="button" data-trix-attribute="headingTwo">h2</button>'
  buttonHTML += '<button class="trix-button" type="button" data-trix-attribute="headingThree">h3</button>'
  buttonHTML += '<button class="trix-button" type="button" data-trix-attribute="headingFour">h4</button>'
  buttonHTML += '<button class="trix-button" type="button" data-trix-attribute="paragraph">P</button>'
  buttonHTML += '<button class="trix-button" type="button" data-trix-attribute="center">Center</button>'

  event.target.toolbarElement.
    querySelector(".trix-button-group").
    insertAdjacentHTML("beforeend", buttonHTML)
})
